import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import { fetchLastRefCountersRoutine, requestAdditionalReferencesRoutine } from '../../routines';
import { getLastRefCounters } from '../../../../services/positionService';

function* getLastCounters({ payload }: Routine<any>) {
  try {
    let data = null;

    if (payload) {
      data = yield call(getLastRefCounters, payload);
    }

    yield put(fetchLastRefCountersRoutine.success(data));
  } catch {
    yield put(fetchLastRefCountersRoutine.failure());
  }
}

function* watchGetLastCountersRequest() {
  yield takeEvery(fetchLastRefCountersRoutine.TRIGGER, getLastCounters);
  yield takeEvery(requestAdditionalReferencesRoutine.TRIGGER,
    ({ payload: { selectedPosition } }: Routine<any>) => getLastCounters({ payload: selectedPosition?.id }));
}

export default function* step3Saga() {
  yield all([watchGetLastCountersRequest()]);
}
